const mandatoryFields = ['sector_id', 'title', 'seat_group_id', 'Row number', 'Seat number'];
export default mandatoryFields;
